import { useEffect, useState } from 'react';
import { logger } from '@/lib/logger';
import { settingsApi } from './api';

/** The logo of the clinic, loaded with the auth header (a plain <img src> has none). */
export function useLogoUrl(version: string | null): string | null {
  const [url, setUrl] = useState<string | null>(null);
  useEffect(() => {
    if (!version) {
      setUrl(null);
      return;
    }
    let made: string | null = null;
    let live = true;
    settingsApi
      .logoUrl(version)
      .then((u) => {
        made = u;
        if (live) setUrl(u);
        else URL.revokeObjectURL(u);
      })
      .catch((err) => logger.warn('logo failed', err));
    return () => {
      live = false;
      if (made) URL.revokeObjectURL(made);
    };
  }, [version]);
  return url;
}
